// @flow

import * as React from 'react';

import { Check, X } from 'lucide-react';

import { useDispatch } from 'react-redux';

import { View, Icon, Text, Button } from 'reshaped';

import { removeDiscount, selectCartCurrency, getCart } from '@gandi/cart';

import { useTranslator } from '@gandi/translate';

import { useAppSelector } from 'src/hooks/useAppSelector';

type Props = {
  discount:
    | {
        code?: string,
        amount: number,
        label: string,
      }
    // Add type UnusedDiscount export in @gandi/cart UnusedDiscount,
    | {
        id?: number,
        description?: string,
        amount?: number,
        code?: string,
      },
};

function DiscountRow({ discount }: Props): React.MixedElement | null {
  const dispatch = useDispatch();
  const { __, formatPrice } = useTranslator();
  const [loading, setLoading] = React.useState(false);

  const currency = useAppSelector(selectCartCurrency);

  const handleRemoveClick = async (evt: SyntheticEvent<>) => {
    evt.preventDefault();
    setLoading(true);
    try {
      const { code, id } = discount;
      // $FlowFixMe refine here
      await dispatch(removeDiscount(code ? { code } : { id }));
      await dispatch(getCart());
    } catch (err) {
      setLoading(false);
    }
  };

  const code = discount.code;

  if (!discount.amount) {
    return (
      <View
        direction="row"
        align="center"
        justify="space-between"
        wrap={false}
        gap={3}
      >
        <View direction="row" align="center" gap={3} grow>
          <View
            width={6}
            height={6}
            align="center"
            justify="center"
            borderRadius="circular"
            backgroundColor="critical-faded"
            shrink={false}
          >
            <Icon svg={X} color="critical" />
          </View>

          <View direction="column" grow>
            {code ? (
              <Text variant="body-3" as="p">
                {__('The code %(code)s is not applicable.', { code })}
              </Text>
            ) : (
              <Text variant="body-3" as="p">
                {discount.label}
              </Text>
            )}
          </View>
        </View>
      </View>
    );
  }

  if (!code) return null;

  const price = formatPrice(Math.abs(discount.amount), currency);

  return (
    <View direction="row" justify="space-between" align="center">
      <View direction="row" align="center" gap={3}>
        <View
          width={6}
          height={6}
          align="center"
          justify="center"
          borderRadius="circular"
          backgroundColor="positive-faded"
        >
          <Icon svg={Check} color="positive" />
        </View>

        <Text variant="body-3" as="p">
          {__('The code %(code)s has been applied.', {
            code,
          })}
        </Text>
      </View>
      {/* $FlowFixMe[prop-missing] */}
      {!discount.code && !discount.id ? null : (
        <Button
          variant="ghost"
          attributes={{
            title: __('Remove %(code)s (%(price)s discount)', {
              code,
              price,
            }),
          }}
          onClick={handleRemoveClick}
          loading={loading}
        >
          {__('Cancel')}
        </Button>
      )}
    </View>
  );
}

export default DiscountRow;
